<div>
    <ce-ticket-badge *ngFor="let ticket of tickets" [ticket]="ticket"></ce-ticket-badge>
</div>
